import type { ListOrganizationRolesRequest } from '@compass/client/types/organization_role';
import { organizationRoleService } from '@services/api';
import { useQuery } from '@tanstack/react-query';

const queryKeys = {
  organizationRoles: {
    all: ['compass', 'organizationRoles'] as const,
    list: (organizationId: string, params?: Partial<ListOrganizationRolesRequest>) =>
      [...queryKeys.organizationRoles.all, 'list', organizationId, params] as const,
  },
};

/**
 * Hook to list roles within an organization
 */
export const useOrganizationRoles = (
  organizationId?: string,
  params?: Omit<ListOrganizationRolesRequest, 'organization_id'>,
) => {
  return useQuery({
    queryKey: queryKeys.organizationRoles.list(organizationId || '', params),
    queryFn: () => {
      if (!organizationId) {
        throw new Error('Organization ID is required');
      }
      return organizationRoleService.listOrganizationRoles({
        organization_id: organizationId,
        ...params,
      });
    },
    enabled: !!organizationId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });
};
